const navigateToLink = (url, opts = {}) => new Promise((resolve, reject) => {
    const link = document.createElement('a');

    Object.keys(opts).forEach(key => {
        link.setAttribute(key, opts[key]);
    })

    link.href = url;

    link.click()
});

export default navigateToLink;